import React from 'react'
import { Link } from "react-router-dom";
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SearchUI from '../../../widgets/input/SearchUI'
import SelectUI from '../../../widgets/input/SelectUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SendToZybraModalSF from './SendToZybraModalSF'
import CurrentTxnRemarksModalSF from './CurrentTxnRemarksModalSF'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import './NodalTxnList.css'

const CurrentTxnListUI = ({ context, transactionList, onRefreshClick, selectedTxnId,
  accountNumber, onDownloadClick,
  year, month, yearList, monthList, onYearChange, onMonthChange,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  onExternalClick, failSubmitted, onUpdateRemarksClick, details, onDetailsClick,
  updateRemarksMode, onCancelRemarksClick, transactionId, reconciliationStatus, selectedRemarks, climeTxnTypeList,
  txnSent, onSendToZybraClick, zybraCustomerList, customerUpdateMode, onCustomerTxnClick, onCustomerTxnCancelClick
}) =>
  <div className='su_ntxn'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
          onDownloadClick={onDownloadClick}
        />
      }
      right={
        <ActionRightUI
          context={context}
          yearList={yearList} monthList={monthList}
          year={year} month={month}
          onYearChange={onYearChange} onMonthChange={onMonthChange}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    {
      transactionList.length === 0 &&
      <EmptyListUI
        context={context}
        createEnabled={false}
        createDisabledMessageLabel='No transactions'
      />
    }

    {
      transactionList.length > 0 &&
      <div className='g_flex_h'>
        <span>{transactionList.length} transaction{transactionList.length == 1 ? '' : 's'} displayed</span>
        <span className='g_muted'><i>Search by account name, narration, type</i></span>
      </div>
    }

    {
      transactionList.length > 0 &&
      <div className='g_flex_h g_m_bottom_25'>
        <Link to='#' onClick={onDetailsClick}>Details</Link>
        {/*<i>Automatic reconciliation from 16 Oct, 2023</i>*/}
      </div>
    }
    {
      transactionList.length > 0 &&
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Details</th>
            <th>Credit</th>
            <th>Debit</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          {
            !context.permissions.includes('su_superuser') &&
            transactionList.filter(txn => txn.climeTxnType !== 'salary_paid' && txn.climeTxnType !== 'employee_payment').map((txn, i) =>
              <TxnRowList key={i} context={context} txn={txn}
                selectedTxnId={selectedTxnId} transactionId={transactionId}
                onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                onExternalClick={onExternalClick} failSubmitted={failSubmitted} onUpdateRemarksClick={onUpdateRemarksClick}
                txnSent={txnSent} onSendToZybraClick={onSendToZybraClick} details={details} onCustomerTxnClick={onCustomerTxnClick}
              />
            )
          }
          {
            context.permissions.includes('su_superuser') &&
            transactionList.map((txn, i) =>
              <TxnRowList key={i} context={context} txn={txn}
                selectedTxnId={selectedTxnId} transactionId={transactionId}
                onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                onExternalClick={onExternalClick} failSubmitted={failSubmitted} onUpdateRemarksClick={onUpdateRemarksClick}
                txnSent={txnSent} onSendToZybraClick={onSendToZybraClick} details={details} onCustomerTxnClick={onCustomerTxnClick}
              />
            )
          }
        </tbody>
      </table>
    }

    <CurrentTxnRemarksModalSF context={context} accountNumber={accountNumber}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} transactionId={transactionId}
      reconciliationStatus={reconciliationStatus}
      selectedRemarks={selectedRemarks} climeTxnTypeList={climeTxnTypeList}
    />
    <SendToZybraModalSF
      context={context} onRefreshClick={onRefreshClick}
      updateMode={customerUpdateMode} onCancelClick={onCustomerTxnCancelClick}
      transactionId={transactionId} zybraCustomerList={zybraCustomerList}
    />
  </div>

const TxnRowList = ({ context, txn, selectedTxnId, transactionId, details,
  onCopyToClipboard, copyToClipboardText, onExternalClick, failSubmitted, onUpdateRemarksClick, txnSent, onSendToZybraClick,
  onCustomerTxnClick
}) =>
  <tr>
    <td className='g_text_top g_small'>
      <span className='g_no_wrap_2'>{txn.transactionDateF}</span>
    </td>
    <td className='g_text_top g_p_left_50 g_small'>
      <RowLeftUI context={context} txn={txn} details={details} onUpdateRemarksClick={onUpdateRemarksClick}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
      />
      <RemarksUI context={context} txn={txn} selectedTxnId={selectedTxnId} details={details}
        onExternalClick={onExternalClick} failSubmitted={failSubmitted}
        txnSent={txnSent} onSendToZybraClick={onSendToZybraClick} transactionId={transactionId}
        onCustomerTxnClick={onCustomerTxnClick}
      />
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {
        txn.amount >= 0 &&
        <span>{txn.amountF1}</span>
      }

    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {
        txn.amount < 0 &&
        <span>({txn.amountF1})</span>
      }
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {txn.balanceAmountF1}
    </td>
  </tr>

const RowLeftUI = ({ context, txn, onCopyToClipboard, copyToClipboardText, onUpdateRemarksClick, details }) =>
  <div className='g_flex_v'>
    <span className='particulars'>
      <span>{txn.particulars}</span>
      {
        details && context.permissions.includes('su_superuser_business') &&
        txn.reconciliationStatus !== 'reconcile_success' &&
        <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted"
          onClick={onUpdateRemarksClick} data-transaction-id={txn.iciciTransactionId}
          data-recon-status={txn.reconciliationStatus}
        />
      }
    </span>
    {
      details &&
      <>
        <span className='g_muted'>{txn.remarks}</span>
        <span className='g_muted'>{txn.depositBranch}</span>
        <span className=''>
          <span className='g_muted'>{txn.iciciTransactionId}</span>
          <span onClick={e => e.stopPropagation()}>
            <CopyToClipboard text={txn.iciciTransactionId}
              onCopy={onCopyToClipboard}>
              <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
            </CopyToClipboard>
            {
              copyToClipboardText === txn.iciciTransactionId &&
              <span className='g_m_left_50 g_muted'>copied</span>
            }
          </span>
        </span>
        {
          txn.appTxnId &&
          <span className='g_small g_muted'>
            Escrow a/c: {txn.escrowAccountNumber}
            <span className='g_m_left_50'>{txn.appTxnId}</span>
          </span>
        }
        {
          txn.loanId &&
          <span className='g_muted g_small'>Loan: {txn.loanId} {txn.loanName}</span>
        }
      </>
    }
    <span className='g_flex_h g_flex_left'>
      {
        txn.climeTxnType &&
        <span className='g_m_top_25'>
          <BadgeUI label={txn.climeTxnType} />
        </span>
      }
      {
        txn.type &&
        <span className='g_m_top_25'>
          <BadgeUI label={txn.typeBadge} />
          <span className='g_m_left_50'><b>{txn.accountName}</b></span>
          {
            txn.remitter &&
            <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
          }
          {
            txn.payee &&
            <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
          }
        </span>
      }
    </span>
    {
      txn.internalRemarks &&
      <span className='g_muted'>Remarks: {txn.internalRemarks}</span>
    }
  </div>

const RemarksUI = ({ txn, txnSent, onSendToZybraClick, onCustomerTxnClick, transactionId, details }) =>
  <div className='g_flex_v g_text_right'>
    <span className='g_flex_h g_flex_right'>
      {
        txn.reconciliationStatus && txn.reconciliationStatus !== 'reconcile_success' && txn.reconciliationStatus !== 'external_transfer' &&
        <BadgeUI label={txn.reconciliationStatus} />
      }
    </span>
    {/*
      details && txn.syncedWithZybra === false && txn.reconciliationStatus !== 'reconcile_failed' && txn.climeTransfer &&
      <ButtonTinyWithSpinnerUI className='g_text_right'
        label='Send to Zybra' rowId={txn.iciciTransactionId}
        onClick={onCustomerTxnClick} alignLeft={false}
      />
    */}
    {/*
      details && txn.syncedWithZybra === false && txn.reconciliationStatus !== 'reconcile_failed' && !txn.climeTransfer &&
      <ButtonTinyWithSpinnerUI className='g_text_right'
        label='Send to Zybra' rowId={txn.iciciTransactionId}
        onClick={onSendToZybraClick} alignLeft={false}
        busy={transactionId === txn.iciciTransactionId && txnSent}
      />
    */}
  </div>

const ActionLeftUI = ({ context, onRefreshClick, accountNumber, onDownloadClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-download' onClick={onDownloadClick} />
    <span className='g_m_left_100 g_large'><b>Clime Finance Account {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ context, year, month, yearList, monthList, onYearChange, onMonthChange, searchFilter, onSearchFilterChange }) =>
  <div className='g_flex_h'>
    <SelectUI selectedKey={year} optionList={yearList} onChange={onYearChange} placeholder='Year' />
    <SelectUI selectedKey={month} optionList={monthList} onChange={onMonthChange} placeholder='Month' />
    <div className='g_m_left_50' />
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default CurrentTxnListUI
